
import { useQuery } from '@tanstack/react-query';
import { apiRequest } from '@/lib/queryClient';

interface GroupOwnerInfo {
  userId: number;
  isGroupOwner: boolean;
  groupsOwned: number;
}

export const useGroupOwner = (userId: number) => {
  return useQuery({
    queryKey: ['group-owner', userId],
    queryFn: async (): Promise<GroupOwnerInfo> => {
      try {
        const response = await apiRequest('GET', `/api/users/${userId}/group-owner-status`);
        return response;
      } catch (error) {
        console.error('[useGroupOwner] ❌ API error for userId', userId, ':', error);
        // Return default value instead of throwing to prevent UI breaks
        return {
          userId: userId,
          isGroupOwner: false,
          groupsOwned: 0
        };
      }
    },
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
    gcTime: 10 * 60 * 1000, // Keep in cache for 10 minutes
    enabled: !!userId,
    retry: 0, // No retry to prevent UI blocking on timeout
    retryDelay: 0 // No delay
  });
};

// Hook per verificare multiple utenti
export const useMultipleGroupOwners = (userIds: number[]) => {
  return useQuery({
    queryKey: ['group-owners', userIds],
    queryFn: async (): Promise<Record<number, boolean>> => {
      if (userIds.length === 0) return {};
      
      const response = await apiRequest('POST', '/api/users/group-owner-status-bulk', {
        userIds
      });
      return response;
    },
    staleTime: 5 * 60 * 1000,
    enabled: userIds.length > 0
  });
};
